"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { Button } from "@/components/ui";
import AIBadge from "@/components/ui/ai-badge";
export function AIButton() {
  const $ = _c(5);
  const {
    onAI
  } = useEmailComposer();
  if (!onAI) {
    return null;
  }
  let t0;
  if ($[0] !== onAI) {
    t0 = () => onAI();
    $[0] = onAI;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AIBadge size={16} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" onClick={t0} tooltip="Generate with AI">{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}